import { render, staticRenderFns } from "./RoomBindingDialog.vue?vue&type=template&id=dc10a4aa&scoped=true&"
import script from "./RoomBindingDialog.vue?vue&type=script&lang=js&"
export * from "./RoomBindingDialog.vue?vue&type=script&lang=js&"
import style0 from "./RoomBindingDialog.vue?vue&type=style&index=0&id=dc10a4aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc10a4aa",
  null
  
)

export default component.exports